import { render, staticRenderFns } from "./ModalEditSection.vue?vue&type=template&id=736372fd&scoped=true"
import script from "./ModalEditSection.vue?vue&type=script&lang=js"
export * from "./ModalEditSection.vue?vue&type=script&lang=js"
import style0 from "./ModalEditSection.vue?vue&type=style&index=0&id=736372fd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736372fd",
  null
  
)

export default component.exports